import { Box } from '@mui/material'
import { ActionText } from 'components/atoms/Text'
import RequestRetryAlert from 'components/atoms/RequestRetryAlert'
import { useState } from 'react'
import { USER_URL } from 'services/constants'
import { deleteRequest } from 'utils/api'
import { useNavigate } from 'react-router-dom'
import { SIGNUP_DIRECT } from 'routes/constants'
import CommonDialog from 'components/molecules/notificationOverlay/CommonDialog'
import OverlayLoading from 'components/atoms/OverlayLoading'
import { useTranslation } from 'react-i18next'

const DeleteAccountButton = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [requestSentSuccessful, setRequestSentSuccessful] = useState(undefined)
  const [successDialogOpen, setSuccessDialogOpen] = useState(false)
  const [dialogOpen, setDialogOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  const deleteConfirm = async () => {
    setLoading(true)
    const res = await deleteRequest(USER_URL)
    if (res.status === 204) {
      setRequestSentSuccessful(true)
      setDialogOpen(false)
      setSuccessDialogOpen(true)
    } else {
      setRequestSentSuccessful(false)
    }
    setLoading(false)
  }

  const signout = () => {
    localStorage.clear()
    navigate(SIGNUP_DIRECT)
  }
  return (
    <Box>
      <ActionText
        variant='h6'
        color='textSecondary'
        onClick={() => setDialogOpen(true)}>
        {t('profile.deleteAccount')}
      </ActionText>
      <CommonDialog
        open={dialogOpen}
        onClose={deleteAccount => {
          if (deleteAccount) {
            deleteConfirm()
          } else {
            setDialogOpen(false)
          }
        }}
        titleText={t('profile.sorryToSeeYouGo')}
        notificationText={t('profile.areYouSure')}
        cancelText={t('profile.deleteMyAccount')}
        cancelValue={1}
        confirmText={t('common.cancel')}
        confirmValue={0}
        btnContainerProps={{
          flexDirection: 'row-reverse',
          gap: 4,
          spacing: 0
        }}>
        {requestSentSuccessful === false ? <RequestRetryAlert /> : null}
      </CommonDialog>

      <CommonDialog
        open={successDialogOpen}
        onClose={() => signout()}
        titleText={t('profile.accountDeleted')}
        notificationText={t('profile.ifYouChangeMind')}
        cancelText={t('rolePlay.okay')}
      />
      <OverlayLoading open={loading} />
    </Box>
  )
}

export default DeleteAccountButton
